<template>
	<div id="app" :class="{'has-navbar-fixed-top has-navbar-fixed-bottom' : this.windowWidth < 1024 && this.$route.fullPath != '/' &&  !this.$route.fullPath.includes('/admin-quini') && this.loggedIn}">

		<!-- Landing Page or Admin-->
		<div v-if="this.$route.path == '/'">
			<router-view :key="$route.fullPath" />
		</div>
		<!-- /Landing Page -->

		<div v-else>
			
			<div v-if="this.$route.fullPath.includes('/admin-quini') || this.$route.fullPath.includes('/password/reset/') || this.$route.fullPath.includes('/email/verify')">
				<router-view :key="$route.fullPath" />
			</div>

			<div v-else>
				<Header :windowWidth="windowWidth" v-on:toggleMenu="toggleMenu" ref="header" v-on:openRegister="openRegister" v-on:openLogin="openLogin" />

				<div class="wrapper">
					<section class="sidebar is-hidden-desktop" :class="{'isClosed' : this.asideMenu}" v-closable="{exclude:['header'], handler: 'hideMenu'}">
						<aside class="menu" @click.prevent="toggleMenu()">
							<p class="menu-label">General</p>
							<ul class="menu-list">
								<li><router-link class="navbar-item" :class="{'is-active' : $route.path == '/estadistica'}" to="/estadistica"><font-awesome-icon icon="chart-bar" /> Estadisticas</router-link></li>
								<li><router-link class="navbar-item" :class="{'is-active' : $route.path == '/puntos'}" to="/puntos"><font-awesome-icon icon="coins" /> Puntos</router-link></li>
								<li><router-link class="navbar-item" :class="{'is-active' : $route.path == '/reglas'}" to="/reglas"><font-awesome-icon icon="book-open" /> Reglamento</router-link></li>
								<li><router-link class="navbar-item" :class="{'is-active' : $route.path == '/ayuda'}" to="/ayuda"><font-awesome-icon icon="question-circle" /> Ayuda</router-link></li>
							</ul>
							<p class="menu-label">Otros</p>
							<ul class="menu-list">
								<li><router-link class="navbar-item" :class="{'is-active' : $route.path == '/configuracion'}" to="/configuracion"><font-awesome-icon icon="cog" /> Configuración</router-link></li>
								<li><a class="navbar-item has-text-danger" to="#" @click.prevent="logout">Salir</a></li>
							</ul>
						</aside>
					</section>

					<div class="grass-bg" :class="{'with-aside-menu' : !this.asideMenu}">
					
						<div class="container">
							<transition name="fade" mode="out-in" v-show="!loading">
								<router-view :key="$route.fullPath" :windowWidth="windowWidth" />
							</transition>
							<Loading v-show="loading" />
						</div>

					</div>
				</div>
				
				<Footer />
			</div>

			<div class="notification-bottom" v-if="notifications_bcast.length > 0">
				<div class="columns">
					<div class="column is-offset-8-desktop is-4-desktop">
						<NotificationContainer />
					</div>
				</div>
			</div>
		</div>

		<LoginModal :active="loginModal" v-on:closeLogin="closeLogin" v-on:tryRegister="tryRegister"/>
		<LoginModal :active="registroModal" v-on:closeLogin="closeRegister" :register="true"/>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import { mapGetters, mapState } from 'vuex'
	import QuinielazoService from "@/services/QuinielazoService"
	import QuinielazoEcho from "@/services/QuinielazoEcho"
	import Loading from '@/components/Loading'
	import LoginModal from '@/components/LoginModal'

	import NotificationContainer from '@/components/NotificationContainer'
	let handleOutsideClick
	export default {
		components: { NotificationContainer, Header, Footer, Loading, LoginModal},
		computed: {
			...mapGetters(['loggedIn']),
			...mapState('notification',['notifications_bcast']),
			...mapState('user',['user']),
			...mapState('login',['loginModal','registroModal'])
		},
		methods: {
			login(){
				this.$router.push({name: 'login'})
			},
			registro(){
				this.$router.push({name: 'registro'})
			},
			logout(){
				this.toggleMenu()
				this.$store.dispatch('logout')
			},
			getSocketId(){
				return new Promise(resolve => {
					QuinielazoEcho.getEchoObject().connector.socket.on('connect', () =>{
						resolve(QuinielazoEcho.getEchoObject().socketId())
					})
				})
			},
			registerEchoListeners(){
				QuinielazoEcho.setUserToken(this.user.token)
				this.getSocketId().then(socketId  =>{
					QuinielazoService.setxSocketId(socketId)
				});

				//Canal General
				QuinielazoEcho.channel('general')
				.listen('.partido.activado', message => {
					//Mostrar notifiacion
					this.$store.dispatch('notification/add',{
						message: "Se agrego un nuevo partido <strong>"+message.partido.equipo_local.nombre+" VS "+message.partido.equipo_visitante.nombre+"</strong>"
					})
					//Push a partidos disponibles
					this.$store.dispatch('partidos/addpartido', message.partido)
				})
				.listen('.partido.desactivado', message => {
					//Quitar de partidos disponibles
					this.$store.dispatch('partidos/removepartido', message.partido)
				})
				.listen('.partido.cambia-estado', message => {
					this.$store.dispatch('notification/add',{
						icon: 'futbol',
						message: "Termino el partido <strong>"+message.partido.equipo_local.nombre+" VS "+message.partido.equipo_visitante.nombre+"</strong>"
						//' ( " + message.partido.goles_local + " - " + message.partido.goles_visitante + " )"
					})
				})
				.listen('.quiniela.creada',message => {
					this.$store.dispatch('notification/add',{
						timeout: 10000,
						message: "Se agrego una nueva quiniela publica <strong>"+message.quiniela.nombre+"</strong> con apuesta de " + message.quiniela.apuesta + ' puntos'
					})
					console.log('intentando agregar quiniela a publicas')
					//Push a quinielas publicas
					this.$store.dispatch('quinielas/addPublica', message.quiniela)
				})
				.listen('.quiniela.terminada', message => {
					this.$store.dispatch('quinielas/update', message.quiniela)				
				})
				.listen('.quiniela.cambia-estado', message => {
					this.$store.dispatch('quinielas/update', message.quiniela)
				})

				//Private channel for logged user
				QuinielazoEcho.private('user.' + this.user.user.id)
				.listen('.usuario.iniciasesion', message => {
					this.$store.dispatch('notification/add',{
						message: "PRIVATE: El usuario "+message.usuario.name+" ha iniciado sesion"
					})
				})
				.listen('.usuario.cambiado', message => {
					this.$store.dispatch('user/updateUserChanged', message.usuario)
				})
				.listen('.quiniela.solicitud-quiniela', message => {
					this.$store.commit('quinielas/ADD_SOLICITUD', message.solicitud)
				})

				//User notifications
				QuinielazoEcho.private('quinielazo.user.' + this.user.user.id ).notification(notification => {
					this.$store.dispatch('notification/push', notification)
				})

				//Si se desconecto..
				QuinielazoEcho.getEchoObject().connector.socket.on('reconnecting', async () => {
					//y esta en la pagina principal
					if (this.$route.fullPath.includes('/jugar')) {
						//actualizar partidos
						await this.$store.dispatch('partidos/fetchPartidosDisponibles');
					}
				})
			},
			getWindowWidth(){
				this.windowWidth = document.documentElement.clientWidth;
			},
			toggleMenu(){
				if(this.asideMenu){
					this.asideMenu = false
				}else{
					this.asideMenu = true
				}
			},
			hideMenu(){
				this.asideMenu = true
			},
			openLogin(){
				this.$store.dispatch('login/loginOpen')
			},
			closeLogin(){
				this.$store.dispatch('login/loginClose')
			},
			openRegister(){
				this.$store.dispatch('login/loginClose')
				this.$store.dispatch('login/registroOpen')
			},
			closeRegister(){
				this.$store.dispatch('login/registroClose')
			},
			tryRegister(){
				this.openRegister()
				//notificar al usuario que termine el registro
				this.$store.dispatch('notification/add',{
					type: 'success',
					message: 'Completa tu información y haz click en "Registrar" para iniciar!!'
				})
			}
		},
		directives: {
			'closable': {
				bind (el, binding, vnode) {
					handleOutsideClick = (e) => {
						e.stopPropagation()
						const { handler, exclude } = binding.value
						let clickedOnExcludedEl = false
						exclude.forEach(refName => {
							if (!clickedOnExcludedEl) {
								const excludedEl = vnode.context.$refs[refName]
								clickedOnExcludedEl = excludedEl.$el.contains(e.target)
							}
						})
						if (!el.contains(e.target) && !clickedOnExcludedEl) {
							vnode.context[handler]()
						}
					}
					document.addEventListener('click', handleOutsideClick)
					document.addEventListener('touchstart', handleOutsideClick)
				},

				unbind () {
					document.removeEventListener('click', handleOutsideClick)
					document.removeEventListener('touchstart', handleOutsideClick)
				}
			}
		},
		data(){
			return{
				//echo: null,
				socketId: null,
				windowWidth: 0,
				asideMenu: true,
				loading: false
			}
		},
		created(){
			if (this.loggedIn) {
				this.registerEchoListeners()
				//Cargar el usuario otra vez
				this.$store.dispatch('user/fetchLoggedInUser')
			}
		},
		mounted(){
			this.$nextTick(function() {
				window.addEventListener('resize', this.getWindowWidth);
				//Init
				this.getWindowWidth()
			})
		},
		beforeDestroy(){
			window.removeEventListener('resize', this.getWindowWidth)
			if (QuinielazoEcho != undefined) {
				QuinielazoEcho.disconnect();
			}
		},
		beforeCreate() {
			QuinielazoService.getAxiosObject().interceptors.request.use(req => {
				this.loading = true
				return req
			})
			QuinielazoService.getAxiosObject().interceptors.response.use(resp => {
				this.loading = false
				return resp
			})
		}
	};
</script>

<style>
.notification-bottom{
	position: fixed;
	top: 10px;
	z-index: 30;
	width: 100%;
	padding: 0.5em;
}
.has-navbar-fixed-top{
	padding-top: 3.25rem;
}
.has-navbar-fixed-bottom{
	padding-bottom: 3.25rem;
}

.wrapper{
  display: flex;
  height: 100%;
  /* overflow: hidden; */
  /* min-width: 350px; */
}
.sidebar{
	display: flex;
	min-height: 100%;
	flex-grow: 1;
	transition: all .3s;
	max-width: 170px;
	min-width: 170px;
}
.sidebar .menu{
	padding: 20px;
	position: fixed;
}
.sidebar.isClosed{
	flex-grow: 0;
	min-width: 0px;
}
.sidebar.isClosed .menu{
	display: none;
}
aside ul li .is-active{
	background-color: #decec8 !important;
	color: black !important;
}

</style>